<template>
  <div style="max-width: 100%; margin: auto">

    <div class="ma-auto">
      <div class="d-flex align-center my-4">
        <h3 style="margin-right: 15px;">تاکسی 133</h3>
      </div>
    </div>
    <div class="page-f">


    <div class="MyClassUpdate">
      <v-btn @click="ChnageBtn" :style="Style1" style="background-color: rgba(255,202,40,0.37); color: black">
        همه
      </v-btn>
      <v-btn @click="ChnageBtn1" :style="Style2" style="background-color: rgba(255,202,40,0.37); color: black">
        واریزی
      </v-btn>
      <v-btn @click="ChnageBtn2" :style="Style3" style="background-color: rgba(255,202,40,0.37); color: black">
        پرداختی
      </v-btn>
    </div>

    <div  v-if="step == 1 && SearchList.length>0&&!loading">
      <div  v-for="(SearchLists,index) in SearchList" style="background-color: #f6f6f6;margin: 8px;padding: 8px;border-radius: 5px; margin-top: 15px !important;"  :key="index">

        <div class="d-flex justify-space-around align-center mt-2">
          <div class="d-flex justify-content-between pa-2">
            <img
                src="@/assets/images/icons/calendar-month.svg"
                style="width: 20px"
                alt=""
                class="ml-2"
            />
            <h4>{{SearchLists.date}}</h4>
          </div>
          <div class="d-flex justify-content-between pa-2">
            <img
                src="@/assets/images/icons/alarm.svg"
                style="width: 20px"
                alt=""
                class="ml-2"
            />
            <h4>{{SearchLists.time}}</h4>
          </div>
          <div class="d-flex justify-content-between pa-2">
            <img
                src="@/assets/images/icons/sort-ascending.svg"
                style="width: 20px"
                alt=""
                class="ml-2"
            />
            <h4 v-if="SearchLists.type_en != 'dec'" style="color: green">{{SearchLists.type}} </h4>

            <h4 v-if="SearchLists.type_en == 'dec'" style="color: #800000">{{SearchLists.type}} </h4>
          </div>
        </div>

        <hr />

        <div class="container">
          <div v-if="SearchLists.type_en != 'dec'" class="justify-space-between row" style="color: green; align-items: center">
            <div class="col-2">مبلغ</div>
            <div class="col-5 my-auto"><hr /></div>
            <div class="col-3">{{SearchLists.amount}} تومان</div>
          </div>

          <div v-if="SearchLists.type_en == 'dec'" class="justify-space-between row" style="color: #800000; align-items: center">
            <div class="col-2">مبلغ</div>
            <div class="col-5 my-auto"><hr /></div>
            <div class="col-3">{{SearchLists.amount}} تومان</div>
          </div>

          <div class="justify-space-between row" style="align-items: center">
            <div class="col-2">موجودی</div>
            <div class="col-5 my-auto"><hr /></div>
            <div class="col-3">{{SearchLists.new_credit}} تومان</div>
          </div>
        </div>
        <hr />
        <h4 class="mt-3">مبلغ مورد نظر بابت تسویه با شناسه {{SearchLists.id}} واریز گردید</h4>
      </div>

      <div v-if="SearchList.length>0&&loadmore&&!loading" @click="ReloadMethods()" class="LoadLazyAdd mb-3">
        نمایش بیشتر
      </div>
      <v-row v-if="SearchList.length===0&&!loading" class="justify-center align-center mt-3" style="height:90%">

        <div>
          <v-img
              src="/app/img/notfound.jpg"
              alt="Alt text"
              width="320"
              height="280"
          ></v-img>
        </div>

      </v-row>
      <v-row v-if="SearchList.length===0&&loading" class="justify-center align-center mt-3" style="height:90%">

        <v-progress-linear  indeterminate style="    height: 5px;
    width: 82%;
    margin-top: 10rem;"></v-progress-linear>

      </v-row>
    </div>

    <div  v-if="step == 2 && SearchList1.length>0&&!loading">
      <div  v-for="(SearchLists,index) in SearchList1" style="background-color: #f6f6f6;margin: 8px;padding: 8px;border-radius: 5px; margin-top: 15px !important;" :key="index">

        <div class="d-flex justify-space-around align-center mt-2">
          <div class="d-flex justify-content-between pa-2">
            <img
                src="@/assets/images/icons/calendar-month.svg"
                style="width: 20px"
                alt=""
                class="ml-2"
            />
            <h4>{{SearchLists.date}}</h4>
          </div>
          <div class="d-flex justify-content-between pa-2">
            <img
                src="@/assets/images/icons/alarm.svg"
                style="width: 20px"
                alt=""
                class="ml-2"
            />
            <h4>{{SearchLists.time}}</h4>
          </div>
          <div class="d-flex justify-content-between pa-2">
            <img
                src="@/assets/images/icons/sort-ascending.svg"
                style="width: 20px"
                alt=""
                class="ml-2"
            />
            <h4 style="color: green">{{SearchLists.type}} </h4>
          </div>
        </div>

        <hr />

        <div class="container">
          <div class="justify-space-between row" style="color: green; align-items: center">
            <div class="col-2">مبلغ</div>
            <div class="col-5 my-auto"><hr /></div>
            <div class="col-5">{{SearchLists.amount}} تومان</div>
          </div>

          <div class="justify-space-between row" style="align-items: center">
            <div class="col-2">موجودی</div>
            <div class="col-5 my-auto"><hr /></div>
            <div class="col-5">{{SearchLists.new_credit}} تومان</div>
          </div>
        </div>
        <hr />
        <h4 class="mt-3">مبلغ مورد نظر بابت تسویه با شناسه {{SearchLists.id}} واریز گردید</h4>
      </div>
     <div v-if="SearchList1.length>0&&loadmore&&!loading" @click="ReloadMethods1()" class="LoadLazyAdd mb-3">
      نمایش بیشتر
    </div>
      <v-row v-if="SearchList1.length===0&&!loading" class="justify-center align-center mt-3" style="height:90%">

        <div>
          <v-img
              src="/app/img/notfound.jpg"
              alt="Alt text"
              width="320"
              height="280"
          ></v-img>
        </div>

      </v-row>
      <v-row v-if="SearchList1.length===0&&loading" class="justify-center align-center mt-3" style="height:90%">

        <v-progress-linear  indeterminate style="    height: 5px;
    width: 82%;
    margin-top: 10rem;"></v-progress-linear>

      </v-row>
    </div>

    <div  v-if="step == 3 && SearchList2.length>0&&!loading">
      <div  v-for="(SearchLists,index) in SearchList2" style="background-color: #f6f6f6;margin: 8px;padding: 8px;border-radius: 5px; margin-top: 15px !important;" :key="index" >

        <div class="d-flex justify-space-around align-center mt-2">
          <div class="d-flex justify-content-between pa-2">
            <img
                src="@/assets/images/icons/calendar-month.svg"
                style="width: 20px"
                alt=""
                class="ml-2"
            />
            <h4>{{SearchLists.date}}</h4>
          </div>
          <div class="d-flex justify-content-between pa-2">
            <img
                src="@/assets/images/icons/alarm.svg"
                style="width: 20px"
                alt=""
                class="ml-2"
            />
            <h4>{{SearchLists.time}}</h4>
          </div>
          <div class="d-flex justify-content-between pa-2">
            <img
                src="@/assets/images/icons/sort-ascending.svg"
                style="width: 20px"
                alt=""
                class="ml-2"
            />
            <h4 style="color: #800000">{{SearchLists.type}} </h4>
          </div>
        </div>

        <hr />

        <div class="container">
          <div class="justify-space-between row" style="color: #800000; align-items: center">
            <div class="col-2">مبلغ</div>
            <div class="col-5 my-auto"><hr /></div>
            <div class="col-5">{{SearchLists.amount}} تومان</div>
          </div>
          <div class="justify-space-between row" style="align-items: center">
            <div class="col-2">موجودی</div>
            <div class="col-5 my-auto"><hr /></div>
            <div class="col-5">{{SearchLists.new_credit}} تومان</div>
          </div>
        </div>
        <hr />
        <h4 class="mt-3">مبلغ مورد نظر بابت تسویه با شناسه {{SearchLists.id}} واریز گردید</h4>
      </div>
      <div v-if="SearchList2.length>0&&loadmore&&!loading" @click="ReloadMethods2()" class="LoadLazyAdd mb-3">
        نمایش بیشتر
      </div>
      <v-row v-if="SearchList2.length===0&&!loading" class="justify-center align-center mt-3" style="height:90%">

        <div>
          <v-img
              src="/app/img/notfound.jpg"
              alt="Alt text"
              width="320"
              height="280"
          ></v-img>
        </div>

      </v-row>

      <v-row v-if="SearchList2.length===0&&loading" class="justify-center align-center mt-3" style="height:90%">

        <v-progress-linear  indeterminate style="    height: 5px;
    width: 82%;
    margin-top: 10rem;"></v-progress-linear>

      </v-row>
    </div>
    </div>
    <SocketListner ref="MySocketListner" />
    <AndroidGeolocation  />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SocketListner from "../components/SocketListner.vue";
import AndroidGeolocation from "../components/AndroidGeolocation.vue";
export default {
  components: {
    SocketListner,
    AndroidGeolocation,
  },
  data(){
    return{
      step : 1,
      SearchList : [],
      SearchList1 : [],
      SearchList2 : [],
      PageShow : 0,
      PageShow1 : 0,
      PageShow2 : 0,
      Style1 : '',
      Style2 : '',
      Style3 : '',
      time : '',
      loadmore:false,
      loading:true,
    }
  },
  computed: {
    ...mapGetters(['baseUrl', "auth"]),
  },

  mounted() {
    this.getInfo();
    this.ReloadMethods();
    this.ReloadMethods1();
    this.ReloadMethods2();
    this.ChnageBtn();
    setInterval(() => {
      const now = new Date();
      const options = { hour: 'numeric', minute: 'numeric' };
      this.time = now.toLocaleTimeString([], options);
    }, 1000);
  },
  methods:{
    getInfo() {
      this.userBox = JSON.parse(localStorage.getItem('auth'));
    },
    ReloadMethods(){
      this.loadmore=true;
      this.PageShow += 1;

      fetch(this.baseUrl + '/get-driver-credit-history?&public_token=' + this.userBox.public_token + '&type=' + "all" + '&uid=' + this.userBox.uid + '&page=' + this.PageShow)
          .then(response => response.json())
          .then(json => {
            if (json.result == 0){
              this.PageShow -= 1
            }else {

              // json.data.list.forEach((value) => {
              //   this.SearchList.push(value);
              // });
              this.SearchList= this.SearchList.concat(json.data.list);

              if (json.data.total_page===this.PageShow){
                this.loadmore=false
              }
            }
            this.loading=false
          })
    },
    ReloadMethods1(){
      this.PageShow1 += 1

      fetch(this.baseUrl + '/get-driver-credit-history?&public_token=' + this.userBox.public_token + '&type=' + "inc" + '&uid=' + "229" + '&page=' + this.PageShow1)
          .then(response => response.json())
          .then(json => {
            if (json.result == 0){
              this.PageShow1 -= 1
            }else {
              // json.data.list.forEach((value) => {
              //   this.SearchList1.push(value);
              // });

              this.SearchList1= this.SearchList1.concat(json.data.list);

              if (json.data.total_page===this.PageShow){
                this.loadmore=false
              }
            }
            this.loading=false
          })


    },
    ReloadMethods2(){
      this.PageShow2 += 1

      fetch(this.baseUrl + '/get-driver-credit-history?&public_token=' + this.userBox.public_token + '&type=' + "dec" + '&uid=' + "229" + '&page=' + this.PageShow2)
          .then(response => response.json())
          .then(json => {
            if (json.result == 0){
              this.PageShow2 -= 1
            }else {
              // json.data.list.forEach((value) => {
              //   this.SearchList2.push(value);
              // });

              this.SearchList2= this.SearchList2.concat(json.data.list);

              if (json.data.total_page===this.PageShow){
                this.loadmore=false
              }
            }
            this.loading=false
          })


    },
    ChnageBtn(){
      this.Style1 = "background-color: #ffca28 !important;"
      this.Style2 = ""
      this.Style3 = ""
      this.step = 1
    },
    ChnageBtn1(){
      this.Style2 = "background-color: #ffca28 !important;"
      this.Style1 = ""
      this.Style3 = ""
      this.step = 2
    },
    ChnageBtn2(){
      this.Style3 = "background-color: #ffca28 !important;"
      this.Style1 = ""
      this.Style2 = ""
      this.step = 3
    },
  }
};
</script>

<style scoped>
.MyClassUpdate{
  display: grid;
  grid-template-columns: 31% 31% 31%;
  justify-content: space-between;
  padding: 0 10px;
  padding-top: 20px;
}

.LoadLazyAdd{
  margin: auto;
  width: 50%;
  height: 40px;
  border-radius: 30px;
  text-align: center;
  background: rgb(86, 146, 183);
  margin-top: 30px;
  line-height: 38px;
  color: white;
  cursor: pointer;
}
.page-f{
  height: calc(100vh - 116px);
  overflow: auto;

}
</style>
